import { PropsWithChildren, useState } from 'react'
import styled from 'styled-components'
import { Box } from '@machobear/design-system'
import Icon from '@/components/icon'

const Container = styled.div`
  position: relative;
`

const MoreButton = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: #dfe3e8;
  }
`

export const DropdownMenu = ({ children }: PropsWithChildren) => {
  const [open, setOpen] = useState(false)

  return (
    <Container>
      <MoreButton onClick={() => setOpen(!open)}>
        <Icon id="ellipsis" style={{ width: '20px' }} />
      </MoreButton>

      {open && (
        <Box
          border="borderNeutralLight"
          borderRadius="standard"
          background="body"
          paddingY="xxxsmall"
          display="flex"
          flexDirection="column"
          style={{ position: 'absolute', top: '52px', right: '0', width: '180px', zIndex: 101 }}
          zIndex="dropdown"
        >
          {children}
        </Box>
      )}
    </Container>
  )
}
